import { createAction, props } from '@ngrx/store';
import { MitarbeiterItem } from '../../mitarbeiter.model';

export const loadAllMitarbeiterStart = createAction('MITARBEITERVERWALTUNG::LOAD_ALL_USERS_START', props<{string: string}>() , );
export const loadAllMitarbeiterSucceeded = createAction(
    'MITARBEITERVERWALTUNG::LOAD_ALL_USERS_SUCCEEDED',
    props<{ item: any[] }>(),
);
export const loadAllMitarbeiterFailed = createAction('MITARBEITERVERWALTUNG::LOAD_ALL_USERS_FAILED', props<{ error: Error }>());
